var antPrefixCls = '.ant-dropdown';
var dropdownStyleFn = function dropdownStyleFn(preToken) {
  var _menuCls, _ref, _ref2;
  var token = preToken;
  var menuCls = '.ant-dropdown-menu';
  return _ref2 = {}, _ref2["" + antPrefixCls] = (_ref = {}, _ref[menuCls] = (_menuCls = {
    padding: '4px 0'
  }, _menuCls[menuCls + "-item, " + menuCls + "-menu-submenu"] = {
    borderRadius: 0,
    '&-selected:not(&-disabled)': {
      fontWeight: token.fontWeightStrong
    }
  }, _menuCls['.ant-dropdown-menu-item-group-title'] = {
    color: token.colorText,
    fontWeight: 600
  }, _menuCls['.ant-dropdown-menu-item-group-list'] = {
    margin: 0,
    '.ant-dropdown-menu-item': {
      paddingLeft: 24
    }
  }, _menuCls), _ref), _ref2['.ant-dropdown-menu-submenu .ant-dropdown-menu'] = {
    padding: '4px 0',
    '.ant-dropdown-menu-item': {
      borderRadius: 0
    }
  }, _ref2['.ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title'] = {
    borderRadius: 0
  }, _ref2;
};

export { dropdownStyleFn };
